import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ZonaGeografica } from '../models/zona-geografica';
import { ResourcefulService } from './resourcefulService';



@Injectable({
    providedIn: 'root'
})
export class ZonaGeograficaService extends ResourcefulService<ZonaGeografica>{
    constructor(private httpClient: HttpClient) {
        super(httpClient, ZonaGeografica);
    }
}
